export default __webpack_public_path__ + "26ebaae0635bf3dbcb0f13d9f03f0c0f.svg";